import {useEffect, useState} from "react"

export type LocalStorageHooks<T extends unknown> = readonly [
    value: T,
    setter: (value: T) => unknown
]

export function useLocalStorage<
    T extends unknown
>(key: string, initialValue: T): LocalStorageHooks<T> {
  const [storedValue, setStoredValue] = useState(initialValue)

  // runs on client side only
  useEffect(() => {
    if (typeof initialValue === "function") {
        throw new Error("useLocalStorage hook does not support functions and objects that are not json-serializable")
    }
    const item = window.localStorage.getItem(key)
    if (item === null) {
        return
    }
    try {
        const parsed = JSON.parse(item)
        setStoredValue(parsed)
      } catch (error) {
        console.error("an error occurred when attempting to parse local storage value (Is it json-encoded).", error)
      }
  }, [])

  function setValue(value: T) {
    try {
      setStoredValue(value)
      const stringified = JSON.stringify(value)
      window.localStorage.setItem(key, stringified)
    } catch (error) {
      console.error("useLocalStorage only accepts json-serializable values", error)
    }
  }

  return [storedValue, setValue]
}